<div mat-dialog-title align='center'>
  <img src='/assets/images/logo-black-2.png' height='100px'>
</div>
<div *ngIf='registerWithEmail' style='padding-bottom: 15px'>
  <div mat-dialog-content fxLayout='column'>
    <mat-form-field>
      <mat-label>First Name</mat-label>
      <input matInput placeholder='First Name' [(ngModel)]='player.first'>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Last Name</mat-label>
      <input matInput placeholder='Last Name' [(ngModel)]='player.last'>
    </mat-form-field>
    <mat-form-field *ngIf='false'>
      <mat-label>Index</mat-label>
      <input matInput placeholder='Index' [(ngModel)]='player.handicap'>
    </mat-form-field>
    <mat-form-field>
      <mat-label>eMail</mat-label>
      <input matInput placeholder='eMail' type='email' [(ngModel)]='player.email' required>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Phone</mat-label>
      <input matInput placeholder='Phone (10-digit US)' type='tel' [(ngModel)]='player.contact_phone' required>
      <mat-hint>Required — e.g. (555) 123-4567</mat-hint>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Password</mat-label>
      <input matInput type='password' placeholder='Password' [(ngModel)]='player.password'>
    </mat-form-field>
    {{ response.error }}
  </div>
  <div mat-dialog-actions align='center'>
    <button mat-raised-button color='accent' (click)='registerUser()' [disabled]='!canSubmit || sendingRequest'>Create Account!
      <i *ngIf='sendingRequest' class='fa fa-spinner fa-spin fa-fw'></i>
    </button>
    <button mat-button mat-dialog-close>Nevermind</button>
  </div>
</div>

<button class='facebook-button' style='width:100%' mat-raised-button (click)='signInWithFB()'>
  <div class="social-btn-layout">
    <div class="social-btn-icon">
      <img src="assets\images\facebook-white.png" width='18px'>
    </div>
    <div class="social-btn-text">Continue with Facebook</div>
    <div class="social-btn-icon">
      <i class='fa fa-spinner fa-spin' *ngIf='loginWithFacebook'></i>
    </div>
  </div>
</button>
<button color='warn' style='width:100%' mat-raised-button disabled *ngIf="loginWithGoogle">
  <div class="social-btn-layout">
    <div class="social-btn-text">Signing in with Google...</div>
    <div class="social-btn-icon"><i class='fa fa-spinner fa-spin'></i></div>
  </div>
</button>
<div class="google-btn-wrap" *ngIf="!loginWithGoogle">
  <asl-google-signin-button type="standard" size="large" text="continue_with" theme="outline" width="400"></asl-google-signin-button>
</div>
<button color='' style='width:100%' mat-raised-button class='email-button' (click)='registerWithEmail = !registerWithEmail'>
  <div class="social-btn-layout">
    <div class="social-btn-icon">
      <i class='fa fa-envelope'></i>
    </div>
    <div class="social-btn-text">Continue with Email</div>
    <div class="social-btn-icon"></div>
  </div>
</button>
<div style='text-align: center'><p>Already have an account
  <a style='cursor: pointer; text-decoration-color:green; color:green' (click)='forwardToLogin()'>Login here</a></p>
</div>
